var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Download_2",
    d: "M11.7301 7.29052V3.2815C11.7301 2.85523 12.0701 2.5 12.5001 2.5C12.8851 2.5 13.2113 2.79849 13.263 3.17658L13.2701 3.2815V7.29052L18.05 7.29083C20.43 7.29083 22.3853 9.23978 22.4951 11.6704L22.5 11.8861V16.9254C22.5 19.373 20.6127 21.3822 18.268 21.495L18.06 21.5H6.94C4.56 21.5 2.61409 19.5608 2.50484 17.1213L2.5 16.9047L2.5 11.8758C2.5 9.4281 4.37791 7.40921 6.72199 7.29585L6.93 7.29083H11.73V13.6932L10.13 12.041C9.83 11.7312 9.34 11.7312 9.04 12.041C8.89 12.1959 8.82 12.4024 8.82 12.6089C8.82 12.7659 8.8648 12.9295 8.95952 13.0679L9.04 13.1666L11.95 16.1819C12.09 16.3368 12.29 16.4194 12.5 16.4194C12.6667 16.4194 12.8333 16.362 12.9653 16.2533L13.04 16.1819L15.95 13.1666C16.25 12.8568 16.25 12.3508 15.95 12.041C15.6773 11.7594 15.2475 11.7338 14.9462 11.9642L14.86 12.041L13.27 13.6932V7.29083L11.7301 7.29052Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dd321cff89ed54378ecfb87b9a5fa635.svg";
export { ForwardRef as ReactComponent };